import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { forwardRef } from "react";
import { BORDER_RADIUS } from "../../utils/constants";
import {
  ChartContainer,
  ChartLegend,
  ChartLegendContent,
  ChartTooltip,
  ChartTooltipContent,
} from "./chart";
import {
  PolarAngleAxis,
  PolarGrid,
  Radar,
  RadarChart as RadarChartLib,
} from "recharts";
import { BOX_SHADOW_THEME, INPUT_COLOR_BORDER } from "../../utils/colors";

const RadarChart = forwardRef((props, ref) => {
  const {
    chartData = [],
    chartConfig = {},
    angleKey = "metric",
    title,
    subtitle,
    height = 360,
    hasTooltip = true,
    hasLegend = true,
    hasPolarGrid = true,
    embedded = false,
    sx = {},
  } = props;

  const chartConfigKeys = Object.keys(chartConfig);

  return (
    <Box
      ref={ref}
      sx={{
        ...(embedded
          ? {
              p: 0,
              border: "none",
              boxShadow: "none",
              backgroundColor: "transparent",
            }
          : {
              padding: 3,
              borderRadius: BORDER_RADIUS,
              backgroundColor: "fields.background",
              boxShadow: BOX_SHADOW_THEME,
              border: `1px solid ${INPUT_COLOR_BORDER}`,
            }),
        ...sx,
      }}
    >
      {title && <Typography variant="body1">{title}</Typography>}
      {subtitle && (
        <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
          {subtitle}
        </Typography>
      )}
      <ChartContainer
        config={chartConfig}
        className="aspect-auto w-full"
        style={{ height }}
      >
        <RadarChartLib data={chartData} margin={{ top: 12, bottom: 12 }}>
          {hasPolarGrid && <PolarGrid />}
          <PolarAngleAxis dataKey={angleKey} />
          {hasTooltip && (
            <ChartTooltip
              cursor={false}
              content={<ChartTooltipContent hideLabel />}
            />
          )}
          {hasLegend && (
            <ChartLegend
              wrapperStyle={{
                width: "100%",
                left: 0,
                paddingLeft: 4,
                paddingRight: 4,
              }}
              content={<ChartLegendContent hideLabel />}
            />
          )}
          {chartConfigKeys.map((key) => (
            <Radar
              key={key}
              name={key}
              dataKey={key}
              stroke={`var(--color-${key})`}
              fill={`var(--color-${key})`}
              fillOpacity={0.2}
              strokeWidth={2}
              isAnimationActive={false}
            />
          ))}
        </RadarChartLib>
      </ChartContainer>
    </Box>
  );
});

RadarChart.displayName = "RadarChart";
export default RadarChart;
